module.exports = __webpack_public_path__ + "static/img/logo-bni.c0e5a77d.png";